<h1 mat-dialog-title>{{ feedstock.name }} {{'PROJECT.FINANCIAL_FEEDSTOCK.FIN_INFO'| anessaTranslation: trigger}}</h1>
<mat-dialog-content>
  <form #feedstockForm="ngForm">
    <!--    price section-->
    <div>
      <h3 anessaTranslation="PROJECT.FINANCIAL_FEEDSTOCK.FEED_PRICE"></h3>
      <div class="flex-container">
        <div class="flex-box">
          <div class="form-row">
            <mat-form-field class="input-select" floatLabel="never">
              <mat-select
                [(ngModel)]="feedstock.financial.feeType"
                [placeholder]="('PROJECT.COMMON.PLEASE_SELECT' | anessaTranslation: trigger)"
                name="tipping-fee"
                id="tipping-fee">
                <mat-option
                  *ngFor="let opt of feeTypes"
                  [value]="opt.value"
                >
                {{ opt.name | anessaTranslation: trigger}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="flex-container separator-wrapper" *ngIf="feedstock.financial.feeType !== FinancialFeeType.FREE">
        <div class="flex-box">
          <app-unit-value [units]="'Currency'"
                          name="cost"
                          [inputPlaceholder]="('PROJECT.COMMON.PLEASE_ENTER' | anessaTranslation: trigger)"
                          [dropdownPlaceholder]="('PROJECT.COMMON.CHOOSE' | anessaTranslation: trigger)"
                          [(ngModel)]="feedstock.financial.price"
                          [columns]="[3,4,4]"
          ></app-unit-value>
        </div>
        <div class="separator-text">
          <div>{{'PROJECT.COMMON.PER' | anessaTranslation: trigger}}</div>
        </div>
        <div class="flex-box">
          <app-unit-value [units]="'Mass'"
                          name="amount"
                          [inputPlaceholder]="('PROJECT.COMMON.PLEASE_ENTER' | anessaTranslation: trigger)"
                          [dropdownPlaceholder]="('PROJECT.COMMON.CHOOSE' | anessaTranslation: trigger)"
                          [(ngModel)]="feedstock.financial.amount"
          ></app-unit-value>
        </div>
      </div>
    </div>
    <!--    feedstock cpi-->
    <div *ngIf="feedstock.financial.feeType !== FinancialFeeType.FREE">
      <h3 anessaTranslation="PROJECT.FINANCIAL_FEEDSTOCK.FEED_CPI"></h3>
      <div class="flex-container">
        <div class="flex-box">
          <app-unit-value [units]="'CPI'"
                          name="cpi"
                          [inputPlaceholder]="('PROJECT.COMMON.PLEASE_ENTER' | anessaTranslation: trigger)"
                          [dropdownPlaceholder]="('PROJECT.COMMON.CHOOSE' | anessaTranslation: trigger)"
                          [(ngModel)]="feedstock.financial.feedstockCpi"
                          [enableNegativeValidation]="false"
                          [enablePercentValidation]="false"
          ></app-unit-value>
        </div>
      </div>
    </div>
    <!--    transportation cost-->
    <div>
      <h3 anessaTranslation="PROJECT.FINANCIAL_FEEDSTOCK.T_COST"></h3>
      <div class="flex-container">
        <div class="flex-box">
          <mat-form-field class="input-select">
            <mat-select
              [(ngModel)]="feedstock.financial.useTransport"
              name="transportcostbool"
              id="transportcostbool"
            >
              <mat-option [value]="true">
                {{'PROJECT.COMMON.YES' | anessaTranslation: trigger}}
              </mat-option>
              <mat-option [value]="false">
                {{'PROJECT.COMMON.NO' | anessaTranslation: trigger}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <ng-container *ngIf="feedstock.financial.useTransport">
        <div>
          <h3 anessaTranslation="PROJECT.FINANCIAL_FEEDSTOCK.T_PRICE"></h3>
          <div class="flex-container separator-wrapper">
            <div class="flex-box">
              <app-unit-value [units]="'Currency'"
                              name="transportcost"
                              [inputPlaceholder]="('PROJECT.COMMON.PLEASE_ENTER' | anessaTranslation: trigger)"
                              [dropdownPlaceholder]="('PROJECT.COMMON.CHOOSE' | anessaTranslation: trigger)"
                              [(ngModel)]="feedstock.financial.transportPrice"
                              [columns]="[3,4,4]"
              ></app-unit-value>
            </div>
            <div>
              <div class="separator-text">{{'PROJECT.COMMON.PER' | anessaTranslation: trigger}}</div>
            </div>
            <div class="flex-box">
              <app-unit-value [units]="'Mass'"
                              name="transportamount"
                              [inputPlaceholder]="('PROJECT.COMMON.PLEASE_ENTER' | anessaTranslation: trigger)"
                              [dropdownPlaceholder]="('PROJECT.COMMON.CHOOSE' | anessaTranslation: trigger)"
                              [(ngModel)]="feedstock.financial.transportAmount"
              ></app-unit-value>
            </div>
          </div>
        </div>
        <div>
          <h3 anessaTranslation="PROJECT.FINANCIAL_FEEDSTOCK.T_CPI"></h3>
          <div class="flex-container">
            <div class="flex-box">
              <app-unit-value [units]="'CPI'"
                              name="transportcpi"
                              [inputPlaceholder]="('PROJECT.COMMON.PLEASE_ENTER' | anessaTranslation: trigger)"
                              [dropdownPlaceholder]="('PROJECT.COMMON.CHOOSE' | anessaTranslation: trigger)"
                              [(ngModel)]="feedstock.financial.transportCpi"
                              [enableNegativeValidation]="false"
                              [enablePercentValidation]="false"
                              [columns]="[3,4,4]"
              ></app-unit-value>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="fatbuttongroup">
  <button
    mat-button
    class="btn-fat btn-green"
    type="button"
    (click)="onSaveClick()"
    anessaTranslation="PROJECT.COMMON.SAVE">
  </button>
  <button
    mat-button
    class="btn-fat btn-red"
    type="button"
    (click)="onCancelClick()"
    anessaTranslation="PROJECT.COMMON.CANCEL">
  </button>
</mat-dialog-actions>
